module.exports = __webpack_public_path__ + "3afb8e0918d8477f08aea41355549aa1.pdf";